import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import pathToArrowIcon from 'src/shared/assets/arrowItem.svg'
import pathToYangoIcon from 'src/shared/assets/yango.svg'

export const classes = {
  container: css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: ${spacing(3, 4, 3, 2)};
    text-decoration: none;
    border-radius: 16px;
    background: radial-gradient(83% 84% at 82% 16%, rgba(253, 190, 15, 0.3) 0%, rgba(255, 255, 255, 0) 100%), #f5f5f5;

    &::after {
      position: absolute;
      top: 50%;
      right: 17px;
      width: 10px;
      height: 10px;
      content: '';
      background: url('${pathToArrowIcon}') no-repeat 50% 50%;
      background-size: contain;
      transform: translateY(-50%);
    }

    [dir='rtl'] & {
      padding: ${spacing(3, 2, 3, 4)};

      &::after {
        right: auto;
        left: 17px;
        transform: translateY(-50%) rotate(180deg);
      }
    }
  `,
  desktopPromoContainer: css`
    position: absolute;
    width: 360px;
    right: ${spacing(2)};
    top: ${spacing(11)};

    [dir='rtl'] & {
      right: auto;
      left: ${spacing(2)};
    }
  `,
  containerYandex: css`
    background: radial-gradient(
        30.83% 107.62% at 80.83% 61.46%,
        rgba(253, 190, 15, 0.3) 0%,
        rgba(255, 255, 255, 0) 100%
      ),
      #ffffff;
  `,
  adaptiveGrid: css`
    max-width: 100%;
    flex-basis: 100%;
  `,
  containerYango: css`
    background: radial-gradient(83% 84% at 82% 16%, rgba(255, 52, 39, 0.3) 0%, rgba(255, 255, 255, 0) 100%), #f5f5f5;
  `,
  title: css`
    font-size: 20px;
    font-weight: 500;
    line-height: 23px;
    color: black;
  `,
  text: css`
    font-size: 16px;
    line-height: 19px;
    color: #9e9b98;
  `,
  icon: css`
    position: static;
    top: -22px;
    right: 35px;
    overflow: hidden;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(172deg, rgba(252, 224, 48, 1) 0%, rgba(252, 183, 1, 1) 35%, rgba(252, 183, 1, 1) 100%);
    transform: rotate(-8deg);
  `,
  fullWidthIcon: css`
    position: absolute;
  `,
  iconYandex: css`
    &::after,
    &::before {
      position: absolute;
      bottom: 0;
      width: 24px;
      height: 24px;
      content: '';
    }

    &::before {
      left: 0;
      border-bottom-left-radius: 8px;
      background-color: #f5f4f2;
    }

    &::after {
      right: 0;
      border-bottom-right-radius: 8px;
      background-color: #21201f;
    }
  `,
  iconYango: css`
    background: url('${pathToYangoIcon}') no-repeat 50% 50% #f00;
    background-size: 75%;
  `,
  mobilePromoContainer: css`
    position: absolute;
    left: ${spacing(1)};
    right: ${spacing(1)};
    top: ${spacing(1)};
  `,
}
